export const COURSE_LABELS: Record<string, string> = {
  'core_training': 'Treinamento do Core',
  'legs_glutes': 'Pernas e Glúteos',
  'both': 'Ambos (Core + Pernas)',
  'not_yet': 'Ainda não é aluna',
  'other': 'Outro',
};

export const TRAINING_LEVEL_LABELS: Record<string, string> = {
  'beginner': 'Iniciante — Estou começando agora ou voltando após muito tempo parada',
  'intermediate': 'Intermediária — Já treino há algum tempo, mas sem muita constância ou técnica',
  'advanced': 'Avançada — Treino com regularidade e domino a maioria dos exercícios',
  'very_advanced': 'Muito Avançada — Treino há anos com alto nível de intensidade e consistência',
};

export const TRAINING_LEVEL_SHORT: Record<string, string> = {
  'beginner': 'Iniciante',
  'intermediate': 'Intermediária',
  'advanced': 'Avançada',
  'very_advanced': 'Muito Avançada',
};

export const TRAINING_LOCATION_LABELS: Record<string, string> = {
  'full_gym': 'Academia completa',
  'home_condo_gym': 'Casa ou academia de condomínio',
};

export const RESPONSIBILITY_LABELS: Record<string, string> = {
  'ciente': 'Estou ciente da minha responsabilidade',
  'outro': 'Outro (ver detalhe)',
};

export const MAIN_GOAL_LABELS: Record<string, string> = {
  'weight_loss': 'Emagrecimento',
  'muscle_definition': 'Definição muscular',
  'hypertrophy': 'Hipertrofia',
  'health_maintenance': 'Manutenção da saúde / reabilitação',
};

export const REFERRAL_SOURCE_LABELS: Record<string, string> = {
  'referral': 'Indicação',
  'social_media': 'Redes sociais',
  'other': 'Outro',
};


export const PAR_Q_QUESTIONS: Record<string, string> = {
  question1: '1. Algum médico já disse que você possui algum problema de coração e que só deveria realizar atividade física supervisionado por profissionais de saúde?',
  question2: '2. Você sente dores no peito quando pratica atividade física?',
  question3: '3. No último mês, você sentiu dores no peito quando praticou atividade física?',
  question4: '4. Você apresenta desequilíbrio devido à tontura e/ou perda de consciência?',
  question5: '5. Você possui algum problema ósseo ou articular que poderia ser piorado pela realização de atividade física?',
  question6: '6. Você toma atualmente algum medicamento para pressão arterial e/ou problema de coração?',
  question7: '7. Sabe de alguma outra razão pela qual você não deve praticar atividade física?',
};

export const ANAMNESE_SECTIONS = [
  {
    title: 'Sua relação com a Mariana Mósca',
    fields: ['online_course'],
  },
  {
    title: 'Seu nível de treinamento',
    fields: ['training_level'],
  },
  {
    title: 'Onde e como você vai treinar',
    fields: ['training_location', 'available_equipment', 'weekly_availability', 'available_training_time'],
  },
  {
    title: 'Seu histórico de lesões e dores',
    fields: ['had_injury', 'injury_description', 'has_pain', 'pain_limits_training', 'limited_exercises'],
  },
  {
    title: 'Sua rotina de exercícios',
    fields: ['currently_exercises', 'exercise_modalities', 'time_without_exercise', 'exercise_history', 'enjoys_training', 'used_to_effort'],
  },
  {
    title: 'Sua saúde',
    fields: ['has_nutritional_support', 'takes_medication', 'medications', 'had_surgery', 'surgeries', 'has_chronic_disease', 'chronic_diseases', 'has_family_history', 'family_history_description'],
  },
  {
    title: 'Maternidade e abdômen',
    fields: ['has_children', 'time_since_delivery', 'abdominal_diastasis'],
  },
  {
    title: 'Seus objetivos com a consultoria',
    fields: ['main_goal', 'goal_details'],
  },
  {
    title: 'Para finalizar',
    fields: ['additional_info', 'referral_source', 'motivation'],
  },
];

export const ANAMNESE_FIELD_LABELS: Record<string, string> = {
  online_course: 'Já é aluna de algum curso online da Mariana Mósca?',
  training_level: 'Nível atual de treinamento',
  training_location: 'Onde vai treinar?',
  available_equipment: 'Materiais disponíveis em casa',
  weekly_availability: 'Disponibilidade semanal para treinos',
  available_training_time: 'Tempo disponível para cada treino',
  had_injury: 'Já sofreu alguma lesão ou acidente osteomuscular?',
  injury_description: 'Detalhes da lesão:',
  has_pain: 'Atualmente sente dores em alguma região do corpo?',
  pain_limits_training: 'Essa dor gera alguma limitação no treino hoje?',
  limited_exercises: 'Exercícios que não consegue realizar:',
  currently_exercises: 'Pratica exercícios físicos atualmente?',
  exercise_modalities: 'Quais exercícios pratica:',
  time_without_exercise: 'Há quanto tempo sem exercícios?',
  exercise_history: 'Histórico com exercícios físicos',
  enjoys_training: 'Sente prazer em treinar?',
  used_to_effort: 'Está acostumada a treinar com esforço e desconforto controlado?',
  has_nutritional_support: 'Faz acompanhamento nutricional ou multidisciplinar?',
  takes_medication: 'Faz uso de algum medicamento contínuo?',
  medications: 'Medicamentos:',
  had_surgery: 'Já realizou alguma cirurgia?',
  surgeries: 'Cirurgias realizadas:',
  has_chronic_disease: 'Possui alguma doença crônica?',
  chronic_diseases: 'Doenças crônicas:',
  has_family_history: 'Histórico familiar de diabetes, hipertensão ou doenças cardíacas?',
  family_history_description: 'Detalhes do histórico familiar:',
  has_children: 'Tem filhos?',
  time_since_delivery: 'Tempo desde o último parto:',
  abdominal_diastasis: 'Informações sobre diástase:',
  main_goal: 'Objetivo principal',
  goal_details: 'Detalhes dos objetivos',
  additional_info: 'Informações adicionais',
  referral_source: 'Como conheceu a Consultoria Mariana Mósca?',
  motivation: 'O que motivou a iniciar a consultoria agora?',
};

export const ANAMNESE_FIELD_TYPES: Record<string, 'boolean' | 'text' | 'select'> = {
  online_course: 'select',
  training_level: 'select',
  training_location: 'select',
  available_equipment: 'text',
  weekly_availability: 'select',
  available_training_time: 'select',
  had_injury: 'boolean',
  injury_description: 'text',
  has_pain: 'boolean',
  pain_limits_training: 'boolean',
  limited_exercises: 'text',
  currently_exercises: 'boolean',
  exercise_modalities: 'text',
  time_without_exercise: 'text',
  exercise_history: 'text',
  enjoys_training: 'boolean',
  used_to_effort: 'boolean',
  has_nutritional_support: 'boolean',
  takes_medication: 'boolean',
  medications: 'text',
  had_surgery: 'boolean',
  surgeries: 'text',
  has_chronic_disease: 'boolean',
  chronic_diseases: 'text',
  has_family_history: 'boolean',
  family_history_description: 'text',
  has_children: 'boolean',
  time_since_delivery: 'text',
  abdominal_diastasis: 'text',
  main_goal: 'select',
  goal_details: 'text',
  additional_info: 'text',
  referral_source: 'select',
  motivation: 'text',
};

export const PHOTO_POSITION_LABELS: Record<string, string> = {
  'front': 'Frente',
  'back': 'Costas',
  'right': 'Lado Direito',
  'left': 'Lado Esquerdo',
};
